import React from 'react';
import PropTypes from 'prop-types';

function TOSAndPrivacyStatementText({ classes }) {
  return (
    <p className={classes.text}>
      Please review and agree to our
      {' '}
      <a
        target="_blank"
        href="https://drive.google.com/file/d/101Y30SYGunh3-Q2_itNKhnSzMqeHuj52"
        rel="noopener noreferrer"
      >
        Terms of Service
      </a>
      {' '}
      and
      {' '}
      <a
        target="_blank"
        href="https://drive.google.com/file/d/1-4JKQNnyGQrAT_J_8G5Nbuups4rVqyOR"
        rel="noopener noreferrer"
      >
        Privacy Policy
      </a>
      {' '}
      to continue.
    </p>
  );
}

TOSAndPrivacyStatementText.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default TOSAndPrivacyStatementText;
